<div class="outer-container">
    <div dwRow>
        <div dwCol="12">
            <label>User Type</label>
            <dw-search-select-lookup [(ngModel)]="adminUserTypeId"
                [lookupId]="userTypeLookupId"></dw-search-select-lookup>
        </div>
    </div>
</div>
